// @flow
import { spawn, call, all } from 'redux-saga/effects';
import type { Saga } from 'redux-saga';

import { watchFetchBaseData } from '../app/base';
import { watchFetchSaleData } from '../app/sale';
import { watchFetchProducts } from '../fetchProducts/fetchProducts';
import { watchAddToCart, watchRemoveFromCart } from '../cart/cart';
import { watchUpdateFavorites } from '../favorites/favorites';
import { watchFetchAdminData } from '../admin/admin';
import watchFetchUserData from '../user/user';
import { watchFetchAbTestUserData } from '../abTest/abTest';

export default function* rootSaga(): Saga<void> {
  const sagas = [
    watchFetchBaseData,
    watchFetchSaleData,
    watchFetchProducts,
    watchAddToCart,
    watchRemoveFromCart,
    watchUpdateFavorites,
    watchFetchAdminData,
    watchFetchUserData,
    watchFetchAbTestUserData,
  ];

  /*
    We loop through sagas here so that we can call spawn (https://redux-saga.js.org/docs/api/) on each worker.
    Putting them in a while loop allows us to be able to restart the worker in the event of
    failure (https://redux-saga.js.org/docs/advanced/RootSaga.html#keeping-everything-alive).
  */
  yield all(
    sagas.map((saga) =>
      // eslint-disable-next-line func-names
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (error) {
            // TODO: clean up error messages
            // eslint-disable-next-line no-console
            console.log(error);
          }
        }
      }),
    ),
  );
}
